import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Stack } from '@mui/material';
import 'dayjs/locale/en-gb';
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import './App.css';
import MenuCarImage from './assets/images/menu/menu_car_route.png';
import MenuHomeImage from './assets/images/menu/menu_home.png';
import MenuReportImage from './assets/images/menu/menu_report.png';
import MenuSettingsImage from './assets/images/menu/menu_settings.png';
import { StyleConstants, Styles } from './Styles';
import AppContext from './AppContext';

const Menu = () => {
    const { pagePaths, setAccessToken, setPagePaths } = useContext(AppContext);

    const logout = () => {
        setAccessToken('');
        setPagePaths([]);
    };

    return (
        <>
            <Stack direction="column" sx={{ width: '61px', borderLeft: '3px solid ' + StyleConstants.borderColor, textAlign: 'end', alignItems: 'flex-end' }}>
                <Box sx={{ height: '100%' }}></Box>

                {pagePaths && pagePaths.includes('/') && (
                    <NavLink to="/"><img src={MenuHomeImage} alt="Home" style={Styles.menuItem} /></NavLink>
                )}

                {pagePaths && pagePaths.includes('/car') && (
                    <NavLink to="/car"><img src={MenuCarImage} alt="Car" style={Styles.menuItem} /></NavLink>
                )}

                {pagePaths && pagePaths.includes('/report') && (
                    <NavLink to="/report"><img src={MenuReportImage} alt="Report" style={Styles.menuItem} /></NavLink>
                )}

                {pagePaths && pagePaths.includes('/settings') && (
                    <NavLink to="/settings"><img src={MenuSettingsImage} alt="Settings" style={Styles.menuItem} /></NavLink>
                )}

                {pagePaths && pagePaths.includes('/profile') && (
                    <NavLink to="/profile"><AccountCircleIcon sx={{ ...Styles.menuItem, color: StyleConstants.fontColor }} alt="User Profile" /></NavLink>
                )}
                
                <LogoutIcon sx={{ ...Styles.menuItem, color: StyleConstants.fontColor }} onClick={logout} />

                <Box sx={{ ...Styles.menuItem }}></Box>
            </Stack>
        </>
    );
};

export default Menu;